module.exports={
	"Form": "UserEditManifest",
	"Scope": "User-Edit",
	"Descriptors":
	{
		"UserDetails.IDUser":
		{
			"Name": "User ID",
			"Hash": "UserEdit-IDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "UserEditIdentity",
				"Group": "UserEditIdentity"
			}
		},
		"UserDetails.GUIDUser":
		{
			"Name": "GUID",
			"Hash": "UserEdit-GUIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "UserEditIdentity",
				"Group": "UserEditIdentity"
			}
		},
		"UserDetails.NameFirst":
		{
			"Name": "First Name",
			"Hash": "UserEdit-NameFirst",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 3,
				"Section": "UserEditIdentity",
				"Group": "UserEditIdentity"
			}
		},
		"UserDetails.NameLast":
		{
			"Name": "Last Name",
			"Hash": "UserEdit-NameLast",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 3,
				"Section": "UserEditIdentity",
				"Group": "UserEditIdentity"
			}
		},
		"UserDetails.Email":
		{
			"Name": "Email Address",
			"Hash": "UserEdit-Email",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Placeholder": "user@example.com",
				"Row": "2",
				"Width": 6,
				"Section": "UserEditContact",
				"Group": "UserEditContact"
			}
		},
		"UserDetails.LoginID":
		{
			"Name": "Login ID",
			"Hash": "UserEdit-LoginID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 3,
				"Section": "UserEditContact",
				"Group": "UserEditContact"
			}
		},
		"UserDetails.Role":
		{
			"Name": "Role",
			"Hash": "UserEdit-Role",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 3,
				"Section": "UserEditContact",
				"Group": "UserEditContact"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "UserEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "UserEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact & Access",
			"Hash": "UserEditContact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact & Access",
					"Hash": "UserEditContact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
